<script setup lang="ts">
  defineProps<{
    icon: string,
    title: string,
    description?: string,
  }>()
</script>

<template>
  <div class="text-center py-12">
    <div class="text-gray-500">
      <fa-icon
        :icon="icon"
        class="text-xl" />
    </div>
    <p class="text-gray-500 text-lg font-semibold">
      {{ title }}
    </p>
    <p
      v-if="description"
      class="text-gray-400 text-sm">
      {{ description }}
    </p>
    <slot></slot>
  </div>
</template>
